import React from 'react'
import { LoginComponent } from '../Components/User/LoginComponent'
import { Col, Row, Image } from 'antd'
import logo from '../assets/img/loginPage.png';
// ======================================================================
export const Login = ({ setLoading, showMessage }) => {
    return (
        <div className='login-section'>
            <Row justify="center" align="middle" style={{ height: '100vh' }}>
                <Col xs={23} sm={22} md={21} lg={8} xl={8} style={{ padding: '15px' }}>
                    <LoginComponent setLoading={setLoading} showMessage={showMessage} />
                    <br />
                    <br />
                </Col>
                <Col xs={23} sm={22} md={21} lg={13} xl={13}  >
                    <img src={logo} style={{ width: '100%', borderRadius: '10px', boxShadow: '0 14px 80px rgba(34,35,58,.2)' }} />
                </Col>
            </Row>
        </div>
    )
}



/*import React from 'react'
import { LoginComponent } from '../Components/User/LoginComponent'
import { Col, Row, Image } from 'antd'
import logo from '../assets/img/loginPage.png';
// ======================================================================
export const Login = ({ setLoading, showMessage }) => {
    return (
        <div className='login-section'>
            <Row justify="center" align="middle" style={{ height: '100vh' }}>
                <Col xs={23} sm={22} md={21} lg={8} xl={8} style={{ padding: '15px' }}>
                    <LoginComponent setLoading={setLoading} showMessage={showMessage} />
                    <br />
                    <br />
                </Col>
                <Col xs={23} sm={22} md={21} lg={13} xl={13}  >
                    <img src={logo} style={{ width: '100%', borderRadius: '10px', boxShadow: '0 14px 80px rgba(34,35,58,.2)' }} />
                </Col>
            </Row>
        </div>
    )
}
*/
/*import React from 'react'
import { LoginComponent } from '../Components/User/LoginComponent'
import { Col, Row, Image } from 'antd'
import logo from '../assets/img/loginPage.png';
// ======================================================================
export const Login = ({ setLoading, showMessage }) => {
    return (
    <div className='login-section'>
        <Row justify="center" align="middle" style={{ height: '100vh' }}>
            {/* فرم بزرگتر *//*}
          /*  <Col xs={23} sm={22} md={20} lg={10} xl={10} style={{ padding: '15px' }}>
                <LoginComponent setLoading={setLoading} showMessage={showMessage} />
                <br />
                <br />
            </Col>
            
            {/* تصویر کوچکتر *//*}
          /*  <Col xs={23} sm={22} md={20} lg={8} xl={8}  >
                <img 
                    src={logo} 
                    style={{ 
                        width: '100%', 
                        maxWidth: '400px', // محدود کردن حداکثر عرض
                        borderRadius: '10px', 
                        boxShadow: '0 14px 80px rgba(34,35,58,.2)',
                        display: 'block',
                        margin: '0 auto' // وسط‌چین
                    }} 
                />
            </Col>
        </Row>
    </div>
)
}
*/